import apiClient from '../apiClient';
import { GET_TRANSPORTATION_CATAGORIES_URL } from '../apiUrl';

const getTransportationCatagoriesApi = () => {
  return apiClient.get(GET_TRANSPORTATION_CATAGORIES_URL);
};

export default getTransportationCatagoriesApi;
